import { Component, Vue } from 'vue-property-decorator';

import './contact.scss';

@Component({
  template: require('./contact.html'),
  components: {
  }
})
export class Contact extends Vue {

    emailHidden: boolean = true;

    get emailDisplayText() {
        if (this.emailHidden) {
            return 'contact[at]nanos[dot]io';
        }
        return 'contact@nanos.io';
    }

    get emailHref() {
        if (this.emailHidden) {
            return '';
        }
        return 'mailto:contact@nanos.io';
    }

    onEmailClick(event) {
        if (this.emailHidden) {
            event.preventDefault();
        }
        this.emailHidden = false;
    }
}
